import { get, post, put, DELETE } from "../restTemplate";


export function postSupport(from, body, token){
    return post("/user/support", {from, body}, token)
}